import React, { Component, Fragment } from 'react';
import { Dialog, Slide, Table, TableBody, TableRow, TableCell, AppBar, Toolbar, IconButton, Typography, DialogContent,
    List, ListItem, ListItemText, ListItemSecondaryAction, Divider, ListItemAvatar, DialogTitle,    
} from '@mui/material';
import Currency from '../common/Currency';
import { isEmpty, size } from "lodash";
import { Close, ArrowBack } from '@mui/icons-material';
import TitleWithEndAction from '../common/TitleWithEndAction';


class SubList extends Component {
    state = {  }
    render() {
        const { CHILD, category, list, total, SUPPLIERS, parent_name } = this.props;
        return (
            <List>
                <TitleWithEndAction
                    title= " "
                    action={() => this.props.openFormCustom(this.props.category.category_id)}
                />
                <ListItem 
                    button
                >
                    <ListItemText 
                        primary={
                            <Typography >
                                Dépenses totales
                            </Typography>
                        } 
                    />
                    <ListItemSecondaryAction>
                        <ListItemText secondary={<Typography color="primary" ><Currency value={total} /></Typography>} />
                    </ListItemSecondaryAction>
                </ListItem>
                <Divider />
                {list.map( spending => {
                    return (
                        <Fragment key={spending.spending_id}>
                            <ListItem 
                                button 
                                onClick={ () => this.props.handleSingle(spending.spending_id)}
                            >
                                <ListItemText 
                                    primary={
                                        <Typography variant="body1">
                                            {SUPPLIERS[spending.spending_supplier].supplier_name}
                                        </Typography>
                                    } 
                                    secondary={
                                        new Date(spending.spending_date).toLocaleDateString("fr-FR")
                                    }
                                />
                                <ListItemSecondaryAction>
                                    <ListItemText secondary={<Typography color="primary"><Currency value={spending.spending_amount} /></Typography>} />
                                </ListItemSecondaryAction>
                            </ListItem>
                            <Divider />
                        </Fragment>
                    )}
                )}
            </List>
        );
    }
}

export default SubList;